export default __webpack_public_path__ + "static/media/notification-cute.307a8b2a.svg";